import { OriginalRegDocument } from 'cpfr-common';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-19/frontend-ui';
import React from 'react';

type OriginalRegDocumentSelectionProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
    hasTooltip?: boolean;
    tooltipText?: string | React.ReactNode;
    tooltipAriaLabel?: string;
    tootltipTitle?: string;
};

export const OriginalRegDocumentSelection: React.FC<OriginalRegDocumentSelectionProps> = ({
    label,
    name,
    isMandatory = true,
    hasTooltip = false,
    tooltipText,
    tooltipAriaLabel,
    tootltipTitle,
}) => {
    const originalRegDocumentOptions: OriginalRegDocument[] = ['Oui', 'Non'];

    const selectItems: ValidatedSelectItem[] = originalRegDocumentOptions.map(
        (originalRegDocumentOption: OriginalRegDocument) => {
            return { value: originalRegDocumentOption, label: originalRegDocumentOption };
        },
    );

    return (
        <ValidatedSelect
            className="c-form-field--no-floating"
            label={label}
            name={name}
            testId={`test-${name}`}
            selectItems={selectItems}
            emptyByDefault
            tooltip={hasTooltip ? tooltipText : undefined}
            tooltipTitle={tootltipTitle}
            tooltipAriaLabel={tooltipAriaLabel}
            isMandatory={isMandatory}
            required={isMandatory}
            requiredText=" *"
        />
    );
};
